import React, { PureComponent } from 'react';

import CalendarBase from './calendar-base/CalendarBase';
import * as CalendarState from '../../state/reducer/calendar/calendar';
import { getState } from '../../state/store';
import Console from '../../lib/debug';

export default class CalendarView extends PureComponent {
    constructor(props) {
        super(props);
        this.loadCalendarData(props);
    }

    componentWillUpdate(nextProps) {
        this.loadCalendarData(nextProps);
    }

    loadCalendarData(props) {
        const programId = parseInt(props.match.params.programId, 10);
        const year = parseInt(props.match.params.year, 10);
        const month = parseInt(props.match.params.month, 10);
        const infoTree = getState().calendar.infoTree;
        const isLoaded = infoTree.month === month && infoTree.year === year;
        const programMatch =
            infoTree.programId === programId || infoTree.team.id === programId;

        if (isLoaded && programMatch) return;

        CalendarState.loadCalendar(programId, year, month);
    }

    render() {
        Console.render('CalendarView');
        return <CalendarBase />;
    }
}



// WEBPACK FOOTER //
// ./src/view/calendar/CalendarView.jsx